





















































/* eslint-disable */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
// import dayjs from 'dayjs';

import Checkbox from '@/components/Checkbox.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import { AxiosError } from 'axios';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

// interface ReportParams {
//   startperiode: String;
//   endperiode: String;
//   transactionNumber: String;
//   email: String;
//   phoneNumber: String;
//   merchant: String;
//   status: String;
// }

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    Checkbox,
    ActionPopup,
  },
  methods: {
    format,
  },
})
export default class DataMerchant extends Vue {
  loading = true;
  listDataSprintUser: any[] = [];

  // merchantLoginData: any = this.$store.state.user.user.merchant;
  // params: ReportParams = {} as ReportParams;

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  format!: typeof format;

  mounted() {
    this.getAllMerchants();
  }

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
  }

  async getAllMerchants(page = 1) {
    const { data } = await api.post('/easyinvoice/superadmins', {
      page,
      user_group: 0,
    });
    if (data) {
      this.page = page;
      this.listDataSprintUser = data.merchant_superadmin;
      this.totalPage = Math.ceil(data.total / data.per_page);
      this.from = data.from;
      this.to = data.to;
      this.totalItem = data.total;
    }
    this.loading = false;
    return null;
  } catch(err: any) {
    console.error(err);
    showToast(ToastType.FAILED, 'Oops… Sorry', err.respone.message);
    this.loading = false;
    return err as AxiosError;
  }
}
